<template>
  <v-checkbox
    class="vc-checkbox d-flex align-center ma-0 pa-0"
    hide-details="true"
    :disabled="disabled"
    :ripple="false"
    on-icon="check"
    off-icon=""
    indeterminate-icon="icon-minus-2"
    :indeterminate="indeterminate"
    color="white"
    v-model="selected"
    :label="label"
    :value="value"
  >
    <template #label >
      <div class="d-flex align-center">
        <AvatarImage v-if="avatar && label" class="ms-1 me-3"
          :image-path="avatar.path"
          :name="avatar.name"
          custom-size="24px"
        />
        <span class="checkbox-label" v-if="label">
        {{label}}

        </span>

        <v-tooltip bottom v-if="tooltip && label">
          <template v-slot:activator="{ on }">
            <v-icon class="tooltip-icon ms-2" v-on="on" size="16">icon-Info</v-icon>
          </template>
          {{tooltip}}
        </v-tooltip>
      </div>
    </template>
  </v-checkbox>
</template>


<script>
  import {AvatarImage} from "@/modules/common/components";

  export default {
    name: 'VcCheckbox',
    computed: {
      selected: {
        get(){
          return this.checked
        },
        set(val){
          this.$emit('change', val)
        }
      }
    },
    components: {AvatarImage},
    props:{
      label: String,
      tooltip: String,
      avatar: Object,
      disabled: Boolean,
      indeterminate: Boolean,
      checked: [Boolean, Array],
      value: [String, Boolean, Number]
    }
  }
</script>

<style lang="scss" scoped>
  .vc-checkbox {
    font-family: var(--primary-font-family);

    &::v-deep {
      .v-input__slot .v-input--selection-controls__input {
        width: 16px;
        height: 16px;

        .v-icon {
          color: transparent;
          border: 1px solid rgba(0, 0, 0, 0.2);
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .checkbox-label{
        font-weight: 500;
        font-size: 13px;
      }
      &:not(.v-input--is-disabled) .checkbox-label {
        color: rgba(0,0,0, 0.87);
      }

      .tooltip-icon{
        color: rgba(0, 0, 0, 0.4);
      }
      .avatar-wrapper .avatar-initials {
        font-size: 9px;
        font-weight: 500;
      }

      //STATES

      // INDETERMINATE
      &.v-input--indeterminate:not(.v-input--is-disabled) .v-input--selection-controls__input .v-icon{
        background-color: rgba(84, 210, 140, 1);
        color: white;
      }

      // CHECKED
      &.v-input--is-label-active:not(.v-input--is-disabled) .v-input--selection-controls__input .v-icon{
        background-color: rgba(84, 210, 140, 1);
        color: white;
        border: none;
      }

      // HOVER
      &:not(.v-input--is-disabled):hover:not(:active) .v-input--selection-controls__input .v-icon{
        background-color: rgba(0, 0, 0, 0.03);
      }

      // HOVER + CHECKED/INDETERMINATE
      &.v-input--is-label-active:not(.v-input--is-disabled):hover,
      &.v-input--indeterminate:not(.v-input--is-disabled):hover {
        .v-input--selection-controls__input .v-icon {
          background-color: rgba(84, 210, 140, 0.76);
        }
      }

      //PRESSED + CHECKED/INDETERMINATE
      &.v-input--is-label-active:not(.v-input--is-disabled):active,
      &.v-input--indeterminate:not(.v-input--is-disabled):active {
        .v-input--selection-controls__input .v-icon{
          background-color: rgba(84, 210, 140, 0.5);
        }
      }
      //PRESSED
      &:not(.v-input--is-label-active):not(.v-input--indeterminate):not(.v-input--is-disabled):active .v-input--selection-controls__input .v-icon{
        background: rgba(0, 0, 0, 0.12);
      }

      //FOCUS
      &:not(.v-input--is-disabled):focus .v-input--selection-controls__input .v-icon{
        box-shadow: 0px 0px 0px 3px rgba(0, 147, 184, 0.36);
      }

      //DISABLED
      &.v-input--is-disabled .v-input--selection-controls__input .v-icon{
        background: rgba(0, 0, 0, 0.07);
      }
      &.v-input--is-disabled.v-input--is-label-active .v-input--selection-controls__input .v-icon{
        border: none;
      }
      //  END STATES
    }
  }
</style>
